/**
 * Helper for showing / hiding tabs
 * @param root Object JQuery element to start search from
 * @param tab String Tab name (data-tab=...)
 * @param show boolean To show or not to show
 */
export function showTab(root, tab, show) {
    let t = root.find('.item[data-tab="' + tab + '"]');

    // Show or hide
    if (show) {
        t.show();
    } else {
        t.hide();
    }

}